<template>
  <div class="applyforrecord">
    <headerBar title="申请记录"></headerBar>
    <div class="tabList">
      <div :class="status == 10 ? 'item active' : 'item'" @click="chooseStatus(10)">全部</div>
      <div :class="status == -1 ? 'item active' : 'item'" @click="chooseStatus(-1)">待付款</div>
      <div :class="status == 0 ? 'item active' : 'item'" @click="chooseStatus(0)">已付款</div>
      <div :class="status == 1 ? 'item active' : 'item'" @click="chooseStatus(1)">待发货</div>
      <div :class="status == 2 ? 'item active' : 'item'" @click="chooseStatus(2)">已发货</div>
      <div :class="status == 3 ? 'item active' : 'item'" @click="chooseStatus(3)">已完成</div>
    </div>
    <scroller :on-infinite="infinite" ref="my_scroller" :on-refresh="refresh">
      <div class="list box710">
        <div class="item" v-for="(item, index) in pageData" :key="index">
          <p class="name">{{item.goods_name}}</p>
          <div class="h-f-c-sb">
            <span>申请数量:{{item.num}}</span>
            <span>费用:{{item.money}}</span>
          </div>
          <div class="aplytime">
            <p class="date">申请时间：{{item.create_time | dateformat('YYYY-MM-DD HH:mm:ss')}}</p>
            <div class="balance">
              <div class="date sentsale" v-if="item.status == -1">待付款</div>
              <div class="date sentsale" v-if="item.status == 0">已付款</div>
              <div class="date sentsale" v-if="item.status == 1">待发货</div>
              <div class="date sentsale" v-if="item.status == 2">已发货</div>
              <div class="date sentsale" v-if="item.status == 3">已完成</div>
            </div>
          </div>
          <div class="button">
            <button class="details" @click="lookInfo(item.id)">详情</button>
            <button class="apply" @click="gotoapply(item.id)" v-if="item.status == -1">去付款</button>
            <button class="confirm" @click="confirm(item.id)" v-if="item.status == 2">确认收货</button>
          </div>
        </div>
      </div>
    </scroller>
  </div>
</template>
<script>
import { Toast, MessageBox } from "mint-ui";
export default {
  data() {
    return {
      status: 10, //-1待付款 0已付款 1已生成 2已发货 10全部
      pageData: [],
      dataPage: 0
    };
  },
  mounted() {
    //判断是否登陆
    if (
      !window.localStorage.getItem("is_check_login") ||
      window.localStorage.getItem("is_check_login") == 0
    ) {
      this.$router.push("/login");
    }
  },
  methods: {
    lookInfo(id) {
      this.$router.push("productdetails?order_id=" + id);
    },
    //前往付款
    gotoapply(id) {
      this.$router.push("cashier?order_id=" + id);
    },
    //确认收货
    confirm(order_id) {
      MessageBox.confirm("确认收货吗？", "提示").then(action => {
        this.$request.get(
          "/front/signOrder/orderConfirm",
          { order_id: order_id },
          res => {
            if (res.status == 1) {
              window.location.reload();
            } else {
              Toast(res.msg);
            }
          }
        );
      });
    },
    //选择分类
    chooseStatus(type) {
      this.status = type;
      this.pageData = [];
      this.getlistData(1, 1);
    },
    /**
     * 下拉刷新
     */
    refresh() {
      console.log("refresh");
      this.getlistData(1, 1);
      //关闭动画
      setTimeout(() => {
        this.$refs.my_scroller.finishPullToRefresh();
      }, 1000);
    },
    /**
     * 上拉加载
     */
    infinite(done) {
      console.log("infinite");
      let page = this.dataPage + 1;
      this.getlistData(page, 2, done);
      setTimeout(() => {
        this.$refs.my_scroller.finishInfinite(true);
      }, 1000);
    },
    /**
     * page 分页
     * optType 1下拉刷新，2上拉加载
     */
    getlistData(page, optType, done) {
      console.log("optType", optType);
      let data = {
        page: page,
        status: this.status
      };
      this.$request.get("/front/signOrder/orderList", data, res => {
        console.log(res);
        if (res.status == 1) {
          if (optType == 1) {
            //下拉刷新
            this.pageData = res.result;
            this.dataPage = 1;
          } else if (optType == 2) {
            //上拉加载
            if (res.result.length != 0) {
              //判断是否有数据
              this.pageData = this.pageData.concat(res.result);
              this.dataPage = page;
              if (typeof done == "function") {
                done();
              }
            } else {
              //没有更多数据
              this.$refs.my_scroller.finishInfinite(true);
            }
          }
        } else {
          Toast(res.msg);
        }
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.button {
  padding-top: 0.2rem;
  margin-bottom: 0.05rem;
  text-align: right;
  button {
    margin: 0 0.06rem;
    padding: 0.01rem 0.2rem;
    border-radius: 15px;
    border: 1px solid;
  }
  .details {
    color: #000000;
  }
  .apply {
    color: #a12e2e;
  }
  .confirm {
    color: #00b378;
  }
}
.tabList {
  width: 100%;
  height: 0.8rem;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 0.2rem;
  box-sizing: border-box;
  background: white;
  position: fixed;
  // top: 1rem;
  z-index: 999;
  .item {
    flex: 1;
    text-align: center;
    height: 0.8rem;
    line-height: 0.8rem;
    border-bottom: 2px solid #ffffff;
  }
  .active {
    color: #00b378;
    border-color: #00b378;
  }
}
.aplytime {
  display: flex;
  justify-content: space-between;
}
.sentsale {
  color: green;
}
.applyforrecord {
  padding-top: 0.8rem;
  .list {
    margin-top: 1.8rem;
    .item {
      padding: 0.2rem 0;
      border-bottom: 1px solid #cccccc;
      .name {
        width: 100%;
        display: -webkit-box;
        overflow: hidden;
        -webkit-box-orient: vertical;
        text-overflow: ellipsis;
        -webkit-line-clamp: 2;
        font-weight: 600;
      }
      .h-f-c-sb {
        margin-top: 0.3rem;
        font-size: 0.26rem;
      }
      .date {
        font-size: 0.26rem;
        margin-top: 0.267rem;
      }
    }
    .item:last-child {
      border: none;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/applyForRecord.vue